import moment from 'moment'
import { Webapi } from '@/Webapi'

export const updateDisplayedRoutes = (routes, selectedTerminals, type) =>
    routes
        .filter(({ terminalCode }) => selectedTerminals.some(({ code }) => code === terminalCode))
        .filter((route) => route.type === type)
        .reduce(
            ([low, high, none], route) => {
                const { level } = route.severity
                if (level === 'NORMAL' || level === 'INACTIVE') {
                    return [low, high, [...none, route]]
                }

                if (level === 'MINOR') {
                    return [[...low, route], high, none]
                }

                return [low, [...high, route], none]
            },
            [[], [], []],
        )

export const splitBasedOnTime = (routes, selectedTerminals) =>
    routes
        .filter((route) => route.type === 'MERCHANT')
        .filter(({ terminalCode }) => selectedTerminals.some(({ code }) => code === terminalCode))
        .reduce(
            ([morning, afternoon, evening], route) => {
                if (route.start === null) {
                    return [morning, [...afternoon, route], evening]
                }

                const { iso } = route.start
                const currentHour = moment(iso).format('HH')
                if (currentHour >= 17) {
                    return [morning, afternoon, [...evening, route]]
                }
                if (currentHour < 12) {
                    return [[...morning, route], afternoon, evening]
                }

                return [morning, [...afternoon, route], evening]
            },
            [[], [], []],
        )

export const fetchTerminals = () =>
    Webapi()
        .contentType('application/json')
        .path('settings/regions')
        .get()

export const fetchRoutes = () =>
    Webapi()
        .contentType('application/json')
        .path('trafiki')
        .path('routes')
        .header('include-merchant-routes', true)
        .get()
